export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", locale: "en-US" },
  { code: "zh-CN", label: "简体中文 (Simplified Chinese)", locale: "zh-CN" },
  { code: "zh-TW", label: "繁體中文 (Traditional Chinese)", locale: "zh-TW" },
  { code: "th", label: "ภาษาไทย", locale: "th-TH" },
  { code: "vi", label: "Tiếng Việt", locale: "vi-VN" },
  { code: "ms", label: "Bahasa Melayu", locale: "ms-MY" },
  { code: "ja", label: "日本語", locale: "ja-JP" },
  { code: "hi", label: "हिन्दी", locale: "hi-IN" },
] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number]["code"];
export interface LanguageState {
  language: Language;
  requestedLanguage: Language;
  status: "idle" | "loading" | "ready" | "error";
  error: string | null;
}

export function isLanguage(value: unknown): value is Language {
  return SUPPORTED_LANGUAGES.some((language) => language.code === value);
}

export function readPreferredLanguage(): Language {
  try {
    const value = localStorage.getItem("locale");
    return isLanguage(value) ? value : "en";
  } catch {
    return "en";
  }
}

let state: LanguageState = {
  language: "en",
  requestedLanguage: readPreferredLanguage(),
  status: "idle",
  error: null,
};
const listeners = new Set<() => void>();

export const getLanguageState = () => state;
export function subscribeLanguage(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function updateLanguageState(next: Partial<LanguageState>): void {
  state = { ...state, ...next };
  listeners.forEach((listener) => listener());
}

export function persistLanguage(language: Language): void {
  try {
    localStorage.setItem("locale", language);
  } catch {
    // Translation still works for this tab when persistent storage is blocked.
  }
}

export function getFormattingLocale(): string {
  return SUPPORTED_LANGUAGES.find((item) => item.code === state.language)!
    .locale;
}
